import { render } from "./ViewDealers.vue?vue&type=template&id=7c073115"
import script from "./ViewDealers.vue?vue&type=script&lang=js"
export * from "./ViewDealers.vue?vue&type=script&lang=js"

import exportComponent from "/srv/strapi/LessMessAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__